var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFastForward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 29.573,
    viewBox: "0 0 50 29.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fast-forward",
    transform: "translate(-31.786 -123.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14611",
    "data-name": "Path 14611",
    d: "M326.591,137.58l-13.942-13.944a.844.844,0,0,0-1.192,0l-3.62,3.62a.844.844,0,0,0,0,1.192l9.729,9.729-9.729,9.727a.844.844,0,0,0,0,1.192l3.62,3.62a.844.844,0,0,0,1.192,0l13.942-13.942A.844.844,0,0,0,326.591,137.58Zm-14.539,13.348-2.43-2.43,9.729-9.727a.844.844,0,0,0,0-1.192l-9.729-9.729,2.43-2.43L324.8,138.176Z",
    transform: "translate(-245.052 0)",
    fill: "#0b2ff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14612",
    "data-name": "Path 14612",
    d: "M188.7,137.58l-13.942-13.944a.844.844,0,0,0-1.192,0l-3.62,3.62a.843.843,0,0,0,0,1.192l9.729,9.729-9.729,9.727a.843.843,0,0,0,0,1.192l3.62,3.62a.844.844,0,0,0,1.192,0L188.7,138.772a.844.844,0,0,0,0-1.192Zm-14.539,13.348-2.43-2.43,9.729-9.727a.844.844,0,0,0,0-1.192l-9.729-9.729,2.43-2.43,12.752,12.754Z",
    transform: "translate(-122.534 0)",
    fill: "#0b2ff7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14613",
    "data-name": "Path 14613",
    d: "M50.787,137.58,36.844,123.636a.844.844,0,0,0-1.192,0l-3.62,3.62a.844.844,0,0,0,0,1.192l9.729,9.729L32.032,147.9a.844.844,0,0,0,0,1.192l3.62,3.62a.844.844,0,0,0,1.192,0l13.942-13.942A.844.844,0,0,0,50.787,137.58ZM36.248,150.928l-2.43-2.43,9.729-9.727a.844.844,0,0,0,0-1.192l-9.729-9.729,2.43-2.43L49,138.176Z",
    transform: "translate(0 0)",
    fill: "#0b2ff7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastForward);
export default __webpack_public_path__ + "static/media/fast-forward.5952676692915ff45d8bd41ce00c2d23.svg";
export { ForwardRef as ReactComponent };